import React from 'react'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {IssueModuleIcon, CircleIcon} from '@csrc/assets/icons'

export const issuesNavigation = [
	{
		id: 'act.actions.actions',
		title: 'actions.nav.issues',
		icon: <FontAwesomeIcon icon={IssueModuleIcon}/>,
		navLink: '/issues',
		action: 'call',
		resource: 'ACT_VIEW_ISSUE_LIST',
		featureKey: 'act_create_issue'
	}
]
